import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-restaurant-silence',
  templateUrl: './popup-restaurant-silence.component.html',
  styleUrls: ['./popup-restaurant-silence.component.scss']
})
export class PopupRestaurantSilenceComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  close(){
    this.dialog.closeAll()
  }

}
